import React from "react";
import { DAppKitProvider } from '@vechain/dapp-kit-react';
import type { WalletConnectOptions, CertificateArgs } from '@vechain/dapp-kit';
import Authorize from './Authorize'
import { WALLET_CONNECT_PROJECT_ID } from './constants';

const walletConnectOptions: WalletConnectOptions = {
  projectId: WALLET_CONNECT_PROJECT_ID,
  metadata: {
    name: 'Sign In With Vechain',
    description: 'Sign in to your account using your Vechain wallet',
    url: window.location.origin,
    icons: [`https://vechain.energy/favicon.png`],
  },
};

export default function App() {
  const url = new URL(window.location.href)
  const network = url.searchParams.get('network') || 'main'

  const scope = url.searchParams.get('scope') || ''
  const code = url.searchParams.get('code') || ''

  const cleanScopeList = scope.split(' ').map(scope => String(scope).trim()).filter(scope => scope !== '')
  if (cleanScopeList.includes('ifttt')) {
    cleanScopeList.push('profile')
  }
  const cleanScope = cleanScopeList.join(' ')
  const signContent = cleanScope === '' ? code : `${code}:${cleanScope}`

  const cert: CertificateArgs = {
    message: {
      purpose: "identification",
      payload: {
        type: "text",
        content: signContent
      }
    }
  }

  return (
    <DAppKitProvider
      nodeUrl={`https://node-${network}net.vechain.energy`}
      genesis={network}
      usePersistence={false}
      walletConnectOptions={walletConnectOptions}
      requireCertificate={true}
      connectionCertificate={cert}
    >
      <Authorize />
    </DAppKitProvider>
  );
}